import { Box } from "@mui/material";
import React from "react";
import VentasChart from "../../Ventas/containers/VentasChart";
import ResumenFacturacion from "../containers/ResumenFacturacion";
import TopProductos from "../containers/TopProductos";
import UltimasVentas from "../containers/UltimasVentas";

export default function Principal() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}  
    >
      <Box
        sx={{
          width: "100%",
          height: "40%",
          display: "flex",
          //flexDirection: "row"
          //gap: 2,
        }}
      >
        <Box
          sx={{
            width: "50%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ResumenFacturacion />
        </Box>
        <Box
          sx={{
            width: "50%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TopProductos/>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "60%",
          display: "flex",
          pl: 2,
          gap: 2.4,
        }}
      >
        <Box
          sx={{
            bgcolor: "#171717",
            width: "46.7%",
            height: "100%",
            display: "flex",
            borderRadius: 2,
          }}
        >
          <VentasChart 
            //height="80%"
            width="100%"
          />
        </Box>
        <Box
          sx={{
            width: "50%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <UltimasVentas />
        </Box>
      </Box>
    </Box>

  );
}